import React from 'react';
import { FiX, FiArrowRight } from 'react-icons/fi';

const PublicQuickLinksModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-charcoal-900/50 dark:bg-charcoal-950/80 backdrop-blur-sm p-4 sm:p-6 transition-opacity duration-300"
      onClick={handleBackdropClick}
    >
      <div className="bg-white dark:bg-charcoal-900 border border-charcoal-200 dark:border-charcoal-700 w-full max-w-md max-h-[90vh] flex flex-col rounded-2xl overflow-hidden shadow-2xl animate-in fade-in-0 zoom-in-95 duration-300">

        {/* Header */}
        <div className="bg-charcoal-50 dark:bg-charcoal-950 px-6 py-4 border-b border-charcoal-200 dark:border-charcoal-800 flex justify-between items-center">
          <div className="flex items-center gap-3 min-w-0 flex-1">
            <img src="/images/Julie_Adams.png" alt="Julie Adams" className="w-8 h-8 rounded-full object-cover flex-shrink-0" />
            <h2 className="text-lg font-bold text-charcoal-900 dark:text-white truncate">SEVEN HATS® Quick Links</h2>
          </div>
          <button
            onClick={onClose}
            className="text-charcoal-400 hover:text-charcoal-600 dark:hover:text-charcoal-300 transition-colors flex-shrink-0"
            aria-label="Close modal"
          >
            <FiX className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto min-h-0">
          <div className="mb-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/50 rounded-xl">
            <h3 className="text-sm font-bold text-blue-900 dark:text-blue-300 mb-2">What Is SEVEN HATS®?</h3>
            <p className="text-sm text-blue-800 dark:text-blue-200 leading-relaxed">
              SEVEN HATS® is the complete strategic operations framework for building and running high-performing marketing functions. It operates at the intersection of executive strategy and operational execution.
            </p>
          </div>

          <div className="space-y-3">
            <a
              href="https://julie-adams.com/fractional-cmo"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between w-full p-4 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-all duration-200 shadow-md hover:shadow-lg"
            >
              <div className="flex flex-col text-left">
                <span className="font-bold">Schedule Discovery Call</span>
                <span className="text-xs opacity-80 font-medium">Explore fractional CMO engagements</span>
              </div>
              <FiArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicQuickLinksModal;
